export default __webpack_public_path__ + "static/media/cam2.bdccecab.png";